"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var lumeColors = ['#5867E8',
// indigo-50
'#001639',
// blue-10
'#06A59A',
// teal-60
'#fcc003' // yellow-80
];
var _default = exports["default"] = lumeColors;
//# sourceMappingURL=lumeColors.js.map